import React from 'react';
import styled from 'styled-components';
import InfoToast from './InfoToast';
import ValidationToast from './ValidationToast';
import ServerErrorToast from './ServerErrorToast';
import DefaultErrorToast from './ErrorToast';
import { useToastContainer } from './hooks';
import { ToastLevel, Toast } from 'models/toasts';

const ToastContainer: React.FC = () => {
  const { toasts, closeToast } = useToastContainer();

  const switchToast = (toast: Toast) => {
    switch (toast.content.level) {
      case ToastLevel.info:
        return <InfoToast toast={toast} />;
      case ToastLevel.validationError:
        return <ValidationToast toast={toast} />;
      case ToastLevel.serverError:
        return <ServerErrorToast toast={toast} />;
      default:
        return <DefaultErrorToast toast={toast} />;
    }
  };

  return (
    <Container>
      {toasts.map((toast, i) => (
        <StyledToast
          key={`Toast_${i}`}
          className="toast show"
          onClick={() => closeToast(toast.toast_id)}
        >
          {switchToast(toast)}
        </StyledToast>
      ))}
    </Container>
  );
};

const Container = styled.div`
  position: absolute;
  top: 40px;
  right: 30px;
  z-index: 9999;
  width: 350px;
  max-height: 100%;
  pointer-events: none;
  .toast:not(:last-child) {
    margin-bottom: 0.75rem;
  }
`;

const StyledToast = styled.div`
  z-index: 30;
  cursor: pointer;
  opacity: 1;
  pointer-events: auto;
`;

export default ToastContainer;
